module.exports = __webpack_public_path__ + "img/IAR13.710310e7.png";